/* tslint:disable */

/**
 */
export class TicketTypeForm {
    sign_form?: string;
    id?: number;
    duration?: number;
    name?: string;
    description?: string;
    order_code?: string;
    sign?: string;
    comany_id?: number;
    number_km?: number;
    sale_of?: number;
    language?: string;
    limit_number?: number;
    charge_limit?: number;
    type?: number;
    price?: number;
    unit?: string;
    is_ticket_transfer?: boolean;
    ticket_transfer_routes?: any;
}
